// Cliente HTTP del escaparate público.
//
// ES OTRO ARCHIVO Y NO EL DE SIEMPRE, y esa es toda la idea. `src/api.js`
// adjunta el token de sesión a cada petición: es su trabajo. Aquí atiende
// un desconocido que no tiene sesión, y usar aquel significaría que una
// tienda abierta en la misma computadora donde alguien dejó su sesión
// mandaría SU token a rutas públicas.
//
// No es una preocupación teórica: la tienda se abre desde un QR pegado en
// el mostrador, con el teléfono del cliente —pero también desde la tableta
// del almacén, donde la sesión del encargado está viva. Este archivo NO
// LEE `localStorage` ni sabe que existe un token, y hay una prueba que lo
// comprueba.
//
// Tampoco manda cookies: `credentials: 'omit'` es explícito para que un
// cambio futuro en el navegador no las cuele por omisión.

export class ErrorTienda extends Error {}

async function procesar(respuesta) {
  let cuerpo = null;
  try {
    cuerpo = await respuesta.json();
  } catch {
    cuerpo = null;
  }
  if (!respuesta.ok) {
    // El servidor escribe sus errores para que se lean: «esta tienda no
    // existe o ya no está disponible, comprueba el enlace o pregunta en el
    // mostrador». Sustituirlos por un «error» genérico tira ese trabajo.
    throw new ErrorTienda(
      cuerpo?.detalle || cuerpo?.detail
      || 'No se pudo conectar con la tienda. Revisa tu conexión e inténtalo otra vez.',
    );
  }
  return cuerpo;
}

function pedir(ruta, opciones = {}) {
  return fetch(`/api/tienda${ruta}`, {
    ...opciones,
    credentials: 'omit',
    headers: { 'Content-Type': 'application/json', ...(opciones.headers || {}) },
  }).then(procesar);
}

export const tienda = {
  ver: (clave) => pedir(`/${encodeURIComponent(clave)}`),

  productos: (clave, { sucursal, buscar = '', limite = 60, desplazamiento = 0 }) => {
    const q = new URLSearchParams({ sucursal, limite, desplazamiento });
    if (buscar) q.set('buscar', buscar);
    return pedir(`/${encodeURIComponent(clave)}/productos?${q}`);
  },

  crearPedido: (clave, datos) => pedir(`/${encodeURIComponent(clave)}/pedidos`, {
    method: 'POST', body: JSON.stringify(datos),
  }),

  verPedido: (clave, folio) =>
    pedir(`/${encodeURIComponent(clave)}/pedidos/${encodeURIComponent(folio)}`),
};
